export default __webpack_public_path__ + "static/media/No50Closed.12f98670.jpg";